import api from '@/core/api/client';
import type { LicensingCatalog, PlanTier } from '@/features/plans';

export interface ModulePackage { id: string; name: string; tier: PlanTier; version: number; capabilityKeys: string[]; linkedPlans: { id: string; name: string }[]; affectedCompanies: number }
export interface ModulePackageDraft { name: string; tier: PlanTier; capabilityKeys: string[]; expectedVersion: number }
export const modulePackagesService = {
  async catalog(): Promise<LicensingCatalog> { return (await api.get('/plans/capabilities')).data.data; },
  async list(): Promise<ModulePackage[]> { return (await api.get('/plans/module-packages')).data.data; },
  async save(id: string | null, input: ModulePackageDraft) {
    return (id ? await api.put(`/plans/module-packages/${id}`, input) : await api.post('/plans/module-packages', input)).data.data;
  },
};
